module.exports = __webpack_public_path__ + "img/weddings_21_H.4f1a4337.webp";